/** Public Esri raster services. Keep one catalogue for the menu and renderer. */
export const MAP_STYLES = [
  { id: 'satellite', label: 'Satellite · full colour', service: 'World_Imagery', maxLevel: 19 },
  { id: 'satellite-labels', label: 'Satellite + labels', service: 'World_Imagery', maxLevel: 19 },
  { id: 'roads', label: 'Roads', service: 'World_Street_Map', maxLevel: 19 },
  { id: 'topographic', label: 'Topographic', service: 'World_Topo_Map', maxLevel: 17 },
  { id: 'light', label: 'Light grey', service: 'Canvas/World_Light_Gray_Base', maxLevel: 16 },
  { id: 'dark', label: 'Dark', service: 'Canvas/World_Dark_Gray_Base', maxLevel: 16 },
] as const;

export type MapStyle = (typeof MAP_STYLES)[number]['id'];
export const ESRI_TILE_ROOT = 'https://server.arcgisonline.com/ArcGIS/rest/services/';
export const ESRI_CREDIT =
  'Esri, Maxar, Earthstar Geographics, USDA, USGS, NASA, HERE, Garmin, OpenStreetMap contributors';
